import { useFeatureValue } from "@growthbook/growthbook-react";
import { yupResolver } from "@hookform/resolvers/yup";
import { GrowthbookFeatures } from "components/growthbook/growthbook.types";
import { EyeClosed } from "components/icons/eye-closed";
import { ClassRating } from "constants/rate-classes";
import Image from "next/legacy/image";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import trackEvent from "services/mixpanel/mixpanel";
import { getEventBasedOnRating } from "services/mixpanel/user-feedback-events";
import { object, number, string, InferType } from "yup";
import RateClassRatings from "../rate-class-ratings/rate-class-ratings";
import { IUserFeedbackFeatureValue } from "../rate-classes.types";
import {
  RateClassModalContent,
  RateClassModalFooter,
  RateClassModalFooterNote,
  RateClassModalHeader,
  RateClassModalHeading,
  RateClassModalImgContainer,
  RateClassModalNote,
  StyledSubmitButton
} from "./rate-class-modal.styles";
import { IRateClassRatingFormProps } from "./rate-class-modal.types";

const FormSchema = object().shape({
  rating: number()
    .test("Rating is required", (value) => {
      return !!value;
    })
    .required(),
  entity_id: string().required()
});

const RateClassRatingForm: React.FC<IRateClassRatingFormProps> = ({
  initialRating,
  onSubmit,
  data
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    formState: { isValid }
  } = useForm<InferType<typeof FormSchema>>({
    defaultValues: {
      rating: initialRating || 0,
      entity_id: data.liveClass.id
    },
    resolver: yupResolver(FormSchema),
    mode: "all",
    reValidateMode: "onChange"
  });

  useEffect(() => {
    register("rating");
  }, [register]);

  const handleRatingClick = (val: ClassRating) => {
    setValue("rating", val);
    trigger("rating");
    trackEvent({
      eventName: getEventBasedOnRating(val),
      payload: {
        classID: data.liveClass.id,
        subject: data.subject.name,
        source: "live class feedback bottom sheet"
      }
    });
  };

  const selectedRating = watch("rating");

  const { teachers, subject } = data;
  const featureValue = useFeatureValue(GrowthbookFeatures.UserFeedback, null);
  if (featureValue) {
    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <RateClassModalHeader>
          <RateClassModalImgContainer>
            {subject.logo && (
              <Image
                src={subject.logo}
                layout="fill"
                alt={subject.name}
                priority
              />
            )}
          </RateClassModalImgContainer>
          <RateClassModalHeading>
            {
              (featureValue as IUserFeedbackFeatureValue).user_feedback_var_key
                .header_bottom_sheet
            }{" "}
            <br />
            {subject.name}
          </RateClassModalHeading>
          <RateClassModalNote>
            {teachers.map(({ name }) => name).join(" & ")}
          </RateClassModalNote>
        </RateClassModalHeader>
        <RateClassModalContent>
          <RateClassRatings
            selectedValue={selectedRating}
            onRatingClick={handleRatingClick}
          />
        </RateClassModalContent>
        <RateClassModalFooter>
          <StyledSubmitButton
            variant="primary"
            disabled={!isValid}
            type="submit"
          >
            Kirim rating
          </StyledSubmitButton>
          <RateClassModalFooterNote>
            <EyeClosed width={24} height={24} />{" "}
            <RateClassModalNote>
              Namamu nggak akan keliatan, kok
            </RateClassModalNote>
          </RateClassModalFooterNote>
        </RateClassModalFooter>
      </form>
    );
  }
  return <></>;
};

export default RateClassRatingForm;
